<div
	[class]="
		cn(
			'pricing',
			size() === 'sm' && 'pricing-sm',
			size() === 'base' && 'pricing-md',
			size() === 'lg' && 'pricing-lg',
			size() === 'xl' && 'pricing-xl'
		)
	"
>
	<div
		[class]="
			cn('pricing-combined', alignment() === 'self-end' && 'text-right')
		"
		data-test-id="price"
	>
		@if (price() === null || requestPrice()) {
			<ng-container
				[ngTemplateOutlet]="iconText"
				[ngTemplateOutletContext]="{
					dataTestId: 'price-type',
					icon: 'hourglass',
					text: 'components.pricing.request' | translate,
				}"
			/>
		} @else if (free()) {
			<ng-container
				[ngTemplateOutlet]="iconText"
				[ngTemplateOutletContext]="{
					dataTestId: 'price-free',
					icon: 'deal',
					text: 'components.pricing.free' | translate,
				}"
			/>
		} @else {
			@if (fromPrice() > 0 && fromPrice() > price()) {
				<vp-price
					[attr.data-test-id]="'price-from'"
					[class]="
						cn(
							alignment() === 'self-end' &&
								isHorizontal() === false &&
								'self-end',
							(alignment() === 'self-start' &&
								isHorizontal() === false) ||
								(isHorizontal() === true && 'self-start')
						)
					"
					[currency]="currency()"
					[price]="fromPrice()"
					[striked]="true"
				/>
			}
			<div [class]="alignment()" class="flex">
				<vp-price
					[attr.data-test-id]="'price-final'"
					[currency]="currency()"
					[price]="price()"
					[size]="size()"
				/>
			</div>

			@if (isHorizontal() === false) {
				<ng-container [ngTemplateOutlet]="conditionsAndIndication" />
			}
		}
	</div>

	@if (isHorizontal() === true) {
		<ng-container [ngTemplateOutlet]="conditionsAndIndication" />
	}
</div>

<ng-template
	#iconText
	let-dataTestId="dataTestId"
	let-icon="icon"
	let-text="text"
>
	<div [attr.data-test-id]="dataTestId" class="flex items-center gap-2">
		<svg-icon
			[src]="`assets/icons/icon-${icon}.svg`"
			class="icon-container icon-container-accent size-4"
		/>
		{{ text }}
	</div>
</ng-template>

<ng-template #conditionsAndIndication>
	@if (conditions()) {
		<div
			[class]="
				cn(
					'pricing-conditions flex flex-row items-center gap-1',
					alignment() === 'self-end' && 'justify-end text-right'
				)
			"
		>
			<span data-test-id="price-label">
				@if (indication()) {
					<span>
						{{ 'components.pricing.indication' | translate }}
					</span>
				}
				{{ conditions() }}
			</span>

			@if (pricingToolTip()) {
				<vp-tooltip
					[fixedHeight]="false"
					alignment="bottom"
					iconSize="size-4"
					tooltipColor="text-dark-tertiary"
				>
					<span vpTooltipContent>
						<vp-pricing-summary
							[currency]="currency()"
							[dateRange]="
								pricingToolTip()?.dateRange ?? undefined
							"
							[items]="pricingToolTip()?.items ?? []"
							[occupancy]="
								pricingToolTip()?.occupancy ?? undefined
							"
							[taxes]="pricingToolTip()?.taxes ?? 0"
							[total]="pricingToolTip()?.total ?? 0"
						/>
					</span>
				</vp-tooltip>
			}
		</div>
	}
</ng-template>
